export default __webpack_public_path__ + "static/media/blueCircle.f6767da9.svg";